<template>
  
  <DiaryViewPage
    v-if="experimentsDiaryWide"
    />
  <DiarywideViewPage
    v-else
    />

</template>




<script setup lang="ts">

const experimentsDiaryWide = useExperimentsDiaryWide()
const impressions = useImpressions()




</script>


<style scoped>

 
</style>